export enum EAiConnectorTab {
  claude = 'claude',
  chatgpt = 'chatgpt',
  other = 'other',
}

/** Where the dialog was opened from - sent as the AI connector events' `source`. */
export enum EAiConnectorSource {
  profile = 'profile',
  sidebarTeaser = 'sidebar_teaser',
  sidebarTeaserCollapsed = 'sidebar_teaser_collapsed',
}

export interface IAiConnectorDialogData {
  source: EAiConnectorSource;
  tab?: EAiConnectorTab;
}
